import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import SectionContainer from '../SectionContainer';
import landingPagePhotos from '../landingPagePhotos';

import css from './SectionPhotoBanner.module.css';

/**
 * A single large real-world photo below a centered header - used to break up the icon-driven
 * sections with actual partner/facility photography instead of illustration.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @param {string} props.sectionId
 * @param {'photoBanner'} props.sectionType
 * @param {keyof landingPagePhotos} props.photo which registered photo to render
 * @param {string?} props.alt accessible description of the photo
 * @param {Object?} props.title header title (Field data)
 * @param {Object?} props.description header description (Field data)
 * @param {Object?} props.appearance
 * @param {Object} props.options
 * @returns {JSX.Element}
 */
const SectionPhotoBanner = props => {
  const {
    sectionId,
    className,
    rootClassName,
    photo,
    alt = '',
    title,
    description,
    appearance,
    options,
  } = props;

  const fieldOptions = { fieldComponents: options?.fieldComponents };
  const hasHeader = hasDataInFields([title, description], fieldOptions);
  const photoSrc = photo && landingPagePhotos[photo];

  return (
    <SectionContainer
      id={sectionId}
      className={classNames(rootClassName || css.root, className)}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeader ? (
        <header className={css.header}>
          <Field data={title} className={css.headerTitle} options={fieldOptions} />
          <Field data={description} className={css.headerDescription} options={fieldOptions} />
        </header>
      ) : null}

      {photoSrc ? (
        <div className={css.frame}>
          <img className={css.photo} src={photoSrc} alt={alt} />
        </div>
      ) : null}
    </SectionContainer>
  );
};

export default SectionPhotoBanner;
